var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LienDefaultProps } from "./Lien.types";
var Lien = function (_a) {
    var Component = _a.as, icone = _a.icone, positionIcone = _a.positionIcone, children = _a.children, taille = _a.taille, otherProps = __rest(_a, ["as", "icone", "positionIcone", "children", "taille"]);
    var classLien = 'fr-link';
    if (icone) {
        classLien += " ".concat(icone);
        if (positionIcone === 'left') {
            classLien += ' fr-link--icon-left';
        }
        else {
            classLien += ' fr-link--icon-right';
        }
    }
    if (taille === "sm" || taille === "lg") {
        classLien += ' fr-link--' + taille;
    }
    // @ts-ignore
    return (React.createElement(Component, __assign({ className: classLien }, otherProps), children));
};
Lien.defaultProps = LienDefaultProps;
export default Lien;
